import Animated from "@-/com.npmjs.react-native-reanimated";
import { SpaceBackdrop } from "@-/dev.improve.haniverse.components.ui.space-backdrop";
import { useLearnMapCoveredOpacityStyle } from "#use-learn-map-covered-opacity-style";

/**
 * Learn's muted backdrop beneath the cards (with the sky, while the space background is on).
 * Every surface that paints the cards' backdrop draws it with this, so that when the map opens it
 * dissolves into the map beneath while the card covers Learn's toolbar, and comes back as the card
 * returns. Mount it as the surface's first child; it takes no touches.
 */
export function LearnMapCardsBackdrop() {
  const style = useLearnMapCoveredOpacityStyle("cards");
  return (
    <Animated.View
      className="absolute inset-0 bg-muted"
      pointerEvents="none"
      style={style}
      testID="learn-map-cards-backdrop"
    >
      <SpaceBackdrop />
    </Animated.View>
  );
}
